import { render, staticRenderFns } from "./TextReading.vue?vue&type=template&id=e0eca5bc&scoped=true&"
import script from "./TextReading.vue?vue&type=script&lang=js&"
export * from "./TextReading.vue?vue&type=script&lang=js&"
import style0 from "./TextReading.vue?vue&type=style&index=0&id=e0eca5bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0eca5bc",
  null
  
)

export default component.exports